import { Component, Mixins } from 'vue-property-decorator';
import { AppHypotheekMixin } from '../mixins/AppHypotheekMixin';
import { State } from 'vuex-class';
import AppUploadDocumentenVue from '@/components/upload-documenten/AppUploadDocumenten.vue';
@Component({
  components: {
    'app-upload-documenten': AppUploadDocumentenVue
  }
})
export default class AppTaxatierapport extends Mixins(AppHypotheekMixin) {
  @State(state => state.config.ppfTaxatierapportVoorwaardenUrl)
  public ppfTaxatierapportVoorwaardenUrl!: string;
  @State(state => state.config.ppfCalcasaTaxatieAanvragenUrl)
  public ppfCalcasaTaxatieAanvragenUrl!: string;

  public ppfContactUrl!: string;

  public get uploadUrl(): string {
    return `Formulieren/Taxatie/${this.hypotheeknummer}`;
  }

  public uploadSucceeded() {
    this.$router.push({ name: 'wijzigen', params: { uploadTaxatieSucceeded: 'true' } });
  }
}
